import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faSchool, faUsers, faGraduationCap } from "@fortawesome/free-solid-svg-icons";

const LearnSection = () => {
  return (
    <section className="py-5" style={{backgroundColor: "#ffffff;"}}>
        <div className="container">
          <div className="text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">What Would You Like To Learn Today?</h2>
          </div>
          <div className="row g-3 justify-content-center">
              <div className="col-lg-3 col-md-6">
                <a href="https://transparent.utah.gov/spending-map/" target="_blank" rel="noopener noreferrer">
                  <button className="btn btn-outline-secondary w-100 py-3">
                    <FontAwesomeIcon icon={faSchool} size="lg" />
                    <br/>
                    My Local School Spending
                  </button>
                  </a>
              </div>

              <div className="col-lg-3 col-md-6">
                <a href="https://old.transparent.utah.gov/ven.php" target="_blank" rel="noopener noreferrer">
                  <button className="btn btn-outline-secondary w-100 py-3">
                    <FontAwesomeIcon icon={faBuilding} size="lg" />
                    <br/>
                    Top State Vendors
                  </button>
                </a>
              </div>

              <div className="col-lg-3 col-md-6">
                <a href="/employees/employee-search" target="_blank" rel="noopener noreferrer">
                  <button className="btn btn-outline-secondary w-100 py-3">
                    <FontAwesomeIcon icon={faUsers} size="lg" />
                    <br/>
                    State Employee Salaries
                  </button>
                </a>
              </div>

              <div className="col-lg-3 col-md-6">
                <a href="/higher-education" target="_blank" 
                  rel="noopener noreferrer">
                  <button className="btn btn-outline-secondary w-100 py-3">
                    <FontAwesomeIcon icon={faGraduationCap} size="lg" />
                    <br/>
                    Higher Education Data
                  </button>
                </a>
              </div>
          </div>
        </div>
    </section>
  )
}

export default LearnSection;